module.exports = __webpack_public_path__ + "static/media/110gb.c94cba47.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/110gb.png
// module id = 81
// module chunks = 0